import { render, staticRenderFns } from "./BlockDetailsModal.vue?vue&type=template&id=b59f984e&scoped=true"
import script from "./BlockDetailsModal.vue?vue&type=script&lang=js"
export * from "./BlockDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./BlockDetailsModal.vue?vue&type=style&index=0&id=b59f984e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f984e",
  null
  
)

export default component.exports